<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <h2 class="common-title">新規相談</h2>
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <template v-else-if="isAdviser">
          <dl class="item">
            アドバイザーは新規相談できません
          </dl>
        </template>
        <template v-else-if="isStaff">
          <dl class="item">
            運営アカウントは新規相談できません
          </dl>
        </template>
        <template v-else>
          <GuideModuleItem :createButton="false" />
          <template v-if="paymentActiveStatus">
            <div class="item" v-if="paymentMode === 'ベーシックプラン'"><strong>現在、{{displayName}}さんはベーシックプランのため、相談件数の上限はありません</strong></div>
          </template>
          <template v-if="isCounsellingExcess">
            <template v-if="paymentActiveStatus">
              <dl class="item">
                <strong>トライアルでご利用可能な相談は1件までです。</strong><br>
                <br>
                ベーシックプランにアップグレードいただくと、相談件数の制限なくご利用いただけます。
                <br>
                <PaymentPlanModuleItem :linkToPaymentPage="true" />
              </dl>
              <div class="item">
                <a href="/payment"><button class="footerNavi-button button-primary">ベーシックプラン（月額770円）にアップグレード</button></a>
              </div>
            </template>
          </template>
          <template v-else>
            <dl class="item">
              <dt class="profile-title">相談内容<span class="must-label">必須</span></dt>
              <dd class="profile-input">
                <textarea v-model="counselingText" placeholder="相談" maxlength="4000"></textarea>
              </dd>
              <dd class="profile-textSmall">※診療・処方にあたる回答はできません</dd>
              <dd class="profile-textSmall">{{counselingText.length}} / 4000文字</dd>
            </dl>

            <dl class="item">
              <dt class="profile-title">関連リンク1</dt>
              <dd class="profile-input">
                <div class="profile-input">
                  <input type="text" v-model="relatedLinkUrl1" placeholder="例) https://cancerwith.com/"  />
                </div>
              </dd>
            </dl>
            <dl class="item">
              <dt class="profile-title">関連リンク2</dt>
              <dd class="profile-input">
                <div class="profile-input">
                  <input type="text" v-model="relatedLinkUrl2" placeholder="例) https://cancerwith.com/" />
                </div>
              </dd>
            </dl>
            <dl class="item">
              <dt class="profile-title">関連リンク3</dt>
              <dd class="profile-input">
                <div class="profile-input">
                  <input type="text" v-model="relatedLinkUrl3" placeholder="例) https://cancerwith.com/" />
                </div>
              </dd>
            </dl>
            <dl class="item">
              <dt class="profile-title">関連リンク4</dt>
              <dd class="profile-input">
                <div class="profile-input">
                  <input type="text" v-model="relatedLinkUrl4" placeholder="例) https://cancerwith.com/" />
                </div>
              </dd>
            </dl>
            <dl class="item">
              <dt class="profile-title">関連リンク5</dt>
              <dd class="profile-input">
                <div class="profile-input">
                  <input type="text" v-model="relatedLinkUrl5" placeholder="例) https://cancerwith.com/" />
                </div>
              </dd>
            </dl>

            <dl class="item">
              <dt class="profile-title">カテゴリ</dt>
              <dd class="profile-input">
                <ul class="radiobox-list">
                  <li v-for="category in categories" :key="category" v-on:change="fetchSubCategory">
                    <input
                      :id="'radio-category-' + category.name"
                      class="input-marker"
                      v-model="selectedCategory"
                      type="radio"
                      v-bind:value="category.name"
                    />
                    <label :for="'radio-category-' + category.name">{{category.name}}</label>
                  </li>
                </ul>
              </dd>
            </dl>

            <dl class="item">
              <dt class="profile-title">サブカテゴリ</dt>
              <dd class="profile-input">
                <ul class="radiobox-list">
                  <li v-for="subCategory in subCategories" :key="subCategory">
                    <input v-if="selectedCategory === ''"
                      :id="'radio-subCategory-' + subCategory.name"
                      class="input-marker"
                      v-model="selectedSubCategory"
                      type="radio"
                      v-bind:value="subCategory.name"
                      disabled
                    />
                    <input v-else
                      :id="'radio-subCategory-' + subCategory.name"
                      class="input-marker"
                      v-model="selectedSubCategory"
                      type="radio"
                      v-bind:value="subCategory.name"
                    />
                    <label :for="'radio-subCategory-' + subCategory.name">{{subCategory.name}}</label>
                  </li>
                </ul>
              </dd>
            </dl>
    

            <dl class="item">
              <!-- TODO：ファイル形式のバリデーション -->
              <dt class="profile-title">写真（1枚目）</dt>
              <dd class="profile-input">
                <div class="profile-input-image avator-image">
                  <img v-show="uploadedImage1" :src="uploadedImage1" style="max-width:350px"/>
                  <img v-show="!uploadedImage1" style="max-width:350px"/>
                </div>
                <div v-show="isUploadImage1Processing" class="loading"></div>
                <input type="file" @change="upload($event, 1)" id="file1" accept="image/*">
              </dd>
            </dl>

            <dl class="item" v-if="uploadedImage1">
              <!-- TODO：ファイル形式のバリデーション -->
              <dt class="profile-title">写真（2枚目）</dt>
              <dd class="profile-input">
                <div class="profile-input-image avator-image">
                  <img v-show="uploadedImage2" :src="uploadedImage2" style="max-width:350px"/>
                  <img v-show="!uploadedImage2" style="max-width:350px"/>
                </div>
                <div v-show="isUploadImage2Processing" class="loading"></div>
                <input type="file" @change="upload($event, 2)" id="file2" accept="image/*">
              </dd>
            </dl>

            <dl class="item" v-if="uploadedImage2">
              <!-- TODO：ファイル形式のバリデーション -->
              <dt class="profile-title">写真（3枚目）</dt>
              <dd class="profile-input">
                <div class="profile-input-image avator-image">
                  <img v-show="uploadedImage3" :src="uploadedImage3" style="max-width:350px"/>
                  <img v-show="!uploadedImage3" style="max-width:350px"/>
                </div>
                <div v-show="isUploadImage3Processing" class="loading"></div>
                <input type="file" @change="upload($event, 3)" id="file3" accept="image/*">
              </dd>
            </dl>

            <button class="footerNavi-button" v-bind:class="{'button-primary':isActiveButtonPrimary, 'button-disabled':isActiveButtonDisabled}" v-on:click="createCounselingTopicsData()">
              相談投稿
            </button>
          </template>
        </template>
      </template>
        
      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton=$route.query.createButton />
      </template>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from "aws-amplify"
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'
import GuideModuleItem from './GuideModule'
import PaymentPlanModuleItem from './PaymentPlanModule'
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsersBySpecificUser } from "./graphql/queries"
import { listUsersBySpecificType } from "./graphql/queries"
import { createCounselingTopics } from "./graphql/mutations"
import { createInformation } from "./graphql/mutations"
import { createMailNotification } from "./graphql/mutations"
import { createErrorLog } from "./graphql/mutations"
import { updateUser } from './graphql/mutations'
import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('CounselingDetailCreate');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'counselingDetailCreate',
  components : {
    HeaderItem,
    FooterItem,
    LoginItem,
    GuideModuleItem,
    PaymentPlanModuleItem,
  },
  mixins:[Common],
  data(){
    return{
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      displayName: '',
      selectedCategory: '',
      categories: [
        {id: 1, name: '診断・治療の悩み'},
        {id: 2, name: '生活・療養の悩み'},
        {id: 3, name: '心の悩み'},
        {id: 4, name: 'その他'}
      ],
      selectedSubCategory: '',
      subCategories: [{id: 1, name: 'カテゴリを選択してください'}],
      uploadedImage1: '',
      uploadedImage2: '',
      uploadedImage3: '',
      counselingText: '',
      imageKey1: '',
      imageKey2: '',
      imageKey3: '',
      imageUploadedIdentityId1: '',
      imageUploadedIdentityId2: '',
      imageUploadedIdentityId3: '',
      identityId: '',
      contactUrl: '',
      questionnaireUrl: '',
      relatedLinkUrl1: '',
      relatedLinkUrl2: '',
      relatedLinkUrl3: '',
      relatedLinkUrl4: '',
      relatedLinkUrl5: '',
      counselledCounts: [],
      nowMonthStr: '',
      isCounsellingExcess: false,
      isLoading: true,
      isActiveButtonPrimary: true,
      isActiveButtonDisabled: false,
      isPostProcessing: false,
      isUploadImage1Processing: false,
      isUploadImage2Processing: false,
      isUploadImage3Processing: false,
      paymentMode: '',
      paymentCustomerId: '',
      paymentSubscriptionStatus: '',
      paymentSubscriptionStartAt: '',
      paymentSubscriptionEndAt: '',
      paymentActiveStatus: false,
    }
  },

  created () {
    this.refresh()
  },

  methods: {

    refresh () {
      Storage.list('')
        .then(result => 
          this.s3Data = JSON.parse(JSON.stringify(result))
        )
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetailCreate',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image List : Storage.list',
              errorNumber: 'CounselingDetailCreate-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetailCreate',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image List : Storage.list',
            errorNumber: 'CounselingDetailCreate-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
        });
    },

    // 画像アップロード
    upload(e, num) {
      this.isPostProcessing = true
      this.isActiveButtonPrimary = false
      this.isActiveButtonDisabled = true
      if (num === 1) {
        this.isUploadImage1Processing = true
      } else if (num === 2) {
        this.isUploadImage2Processing = true
      } else if (num === 3) {
        this.isUploadImage3Processing = true
      }

      var files = e.target.files || e.dataTransfer.files
      var filename = this.id + "-image-" + num + new Date().getTime().toString(16)  + Math.floor(1000 * Math.random()).toString(16) + "-" + files[0].name
      Storage.put(filename, files[0], {
          level: 'protected'
        })
        .then(result => {
          //console.log(result)
          //alert(result)

          if (num === 1) {
            this.imageKey1 = result['key']
            this.imageUploadedIdentityId1 = this.identityId
          } else if (num === 2) {
            this.imageKey2 = result['key']
            this.imageUploadedIdentityId2 = this.identityId
          } else if (num === 3) {
            this.imageKey3 = result['key']
            this.imageUploadedIdentityId3 = this.identityId
          }
          this.download(result['key'], num)
          this.refresh()
          this.isUploadImage1Processing = false
          this.isUploadImage2Processing = false
          this.isUploadImage3Processing = false
          this.isPostProcessing = false
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetailCreate',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image Upload : Storage.put',
              errorNumber: 'CounselingDetailCreate-02',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetailCreate',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image Upload : Storage.put',
            errorNumber: 'CounselingDetailCreate-02',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          this.isUploadImage1Processing = false
          this.isUploadImage2Processing = false
          this.isUploadImage3Processing = false
          this.isPostProcessing = false
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          alert("画像のアップロードに失敗しました")
        })
    },
    download(key, num) {
      Storage.configure({
        level: 'protected'
      })
      Storage.get(key)
        .then(result => {
          //console.log(result)

          if (num === 1) {
            this.uploadedImage1 = result
          } else if (num === 2) {
            this.uploadedImage2 = result
          } else if (num === 3) {
            this.uploadedImage3 = result
          }
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetailCreate',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image Download : Storage.get',
              errorNumber: 'CounselingDetailCreate-03',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetailCreate',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image Download : Storage.get',
            errorNumber: 'CounselingDetailCreate-03',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          alert("画像の取得処理に失敗しました")
        })
    },


    // カテゴリ選択
    fetchSubCategory: function() {
      var subCategories = []
      this.selectedSubCategory = ''
      if (this.selectedCategory == '診断・治療の悩み') {
        subCategories = [
          {id: 1, name: '病院選び'},
          {id: 2, name: '治療方針'},
          {id: 3, name: 'セカンドオピニオン'},
          {id: 4, name: '薬'},
          {id: 5, name: '副作用・後遺症'},
          {id: 6, name: 'その他'}
        ]
      } else if (this.selectedCategory == '生活・療養の悩み') {
        subCategories = [
          {id: 1, name: '情報収集'},
          {id: 2, name: 'ケア用品・サポート用品'},
          {id: 3, name: 'コミュニケーション'},
          {id: 4, name: '食事'},
          {id: 5, name: 'お金'},
          {id: 6, name: '仕事'},
          {id: 7, name: '家族'},
          {id: 8, name: '妊娠・出産'},
          {id: 9, name: '性'},
          {id: 10, name: 'その他'}
        ]
      } else if (this.selectedCategory == '心の悩み') {
        subCategories = [
          {id: 1, name: '死にたい'},
          {id: 2, name: '感情のコントロールができない'},
          {id: 3, name: 'その他'}
        ]
      } else {
        subCategories = [
          {id: 1, name: 'その他'}
        ]
      }
      this.subCategories = subCategories
    },

    // 新規作成保存
    createCounselingTopicsData: async function () {
      if (!this.isPostProcessing) {
        this.isPostProcessing = true
        this.isActiveButtonPrimary = false
        this.isActiveButtonDisabled = true

        // 必須項目チェック
        let errorMessage = ""
        if (!this.counselingText) {
          errorMessage += "【相談内容】が未入力です\n"
        }

        // URLエンコード
        this.relatedLinkUrl1 = encodeURI(this.relatedLinkUrl1)
        this.relatedLinkUrl2 = encodeURI(this.relatedLinkUrl2)
        this.relatedLinkUrl3 = encodeURI(this.relatedLinkUrl3)
        this.relatedLinkUrl4 = encodeURI(this.relatedLinkUrl4)
        this.relatedLinkUrl5 = encodeURI(this.relatedLinkUrl5)


        // 関連リンクのURLチェック
        if (this.relatedLinkUrl1) {
          if (!(this.relatedLinkUrl1.startsWith('http://') || this.relatedLinkUrl1.startsWith('https://'))) {
            errorMessage += "【関連リンク1】の形式が不正です\n"
          }
        }
        if (this.relatedLinkUrl2) {
          if (!(this.relatedLinkUrl2.startsWith('http://') || this.relatedLinkUrl2.startsWith('https://'))) {
            errorMessage += "【関連リンク2】の形式が不正です\n"
          }
        }
        if (this.relatedLinkUrl3) {
          if (!(this.relatedLinkUrl3.startsWith('http://') || this.relatedLinkUrl3.startsWith('https://'))) {
            errorMessage += "【関連リンク3】の形式が不正です\n"
          }
        }
        if (this.relatedLinkUrl4) {
          if (!(this.relatedLinkUrl4.startsWith('http://') || this.relatedLinkUrl4.startsWith('https://'))) {
            errorMessage += "【関連リンク4】の形式が不正です\n"
          }
        }
        if (this.relatedLinkUrl5) {
          if (!(this.relatedLinkUrl5.startsWith('http://') || this.relatedLinkUrl5.startsWith('https://'))) {
            errorMessage += "【関連リンク5】の形式が不正です\n"
          }
        }

        if (errorMessage.length > 0) {
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("保存に失敗しました\n\n" + errorMessage)
          return
        }

        var nowDate = new Date()
        var i = 2 // 待つ日数
        var responseEstimatedDate = new Date(nowDate.getTime() + i*24*60*60*1000 + 9*60*60*1000)


        // counselledCountsを組み立て
        var isExistCount = false
        this.counselledCounts.find(counselledCount => {
          if (counselledCount.month ==  this.nowMonthStr) {
            counselledCount.count = counselledCount.count + 1
            isExistCount = true
          }
        })

        if (!isExistCount) {
          this.counselledCounts.push({"month": this.nowMonthStr, "count": 1})
        }

        const counselingTopicsData = {
          type: 'counselingTopics',
          id: null,
          counselingCategory1: this.selectedCategory,
          counselingCategory2: this.selectedSubCategory,
          counselingText: this.counselingText,
          imageKey1: this.imageKey1,
          imageKey2: this.imageKey2,
          imageKey3: this.imageKey3,
          imageUploadedIdentityId1: this.imageUploadedIdentityId1,
          imageUploadedIdentityId2: this.imageUploadedIdentityId2,
          imageUploadedIdentityId3: this.imageUploadedIdentityId3,
          counselingUserid: this.id,
          responseEstimatedDate: responseEstimatedDate.getUTCFullYear() + '-'
                                  + ('0' + (responseEstimatedDate.getUTCMonth() + 1)).slice(-2) + '-'
                                  + ('0' + responseEstimatedDate.getUTCDate()).slice(-2)
                                  + '+09:00',
          lastResponseDate: null,
          status: '相談中',
          responseStatus: '未回答',
          createAt: new Date(),
          updateAt: new Date()
        }

        if (this.relatedLinkUrl1) {
          counselingTopicsData.relatedLinkUrl1 = this.relatedLinkUrl1
        }
        if (this.relatedLinkUrl2) {
          counselingTopicsData.relatedLinkUrl2 = this.relatedLinkUrl2
        }
        if (this.relatedLinkUrl3) {
          counselingTopicsData.relatedLinkUrl3 = this.relatedLinkUrl3
        }
        if (this.relatedLinkUrl4) {
          counselingTopicsData.relatedLinkUrl4 = this.relatedLinkUrl4
        }
        if (this.relatedLinkUrl5) {
          counselingTopicsData.relatedLinkUrl5 = this.relatedLinkUrl5
        }

        try {
          let createdCounselingTopicsData = await API.graphql(graphqlOperation(
            createCounselingTopics, { input: counselingTopicsData }
          ))

          // Userデータに当月の相談件数を加算
          const userData = {
            id: this.id,
            counselledCounts: JSON.stringify(this.counselledCounts)
          }
          await API.graphql(graphqlOperation(
            updateUser, { input: userData }
          ))

          alert("投稿しました")
          var createdCounselingTopicsId = createdCounselingTopicsData.data.createCounselingTopics.id

          // 新規相談のお知らせをアドバイザー向けに登録
          var notificationStartDate = new Date(nowDate.getTime() + 9*60*60*1000)
          var notificationEndDate = new Date(nowDate.getTime() + i*24*60*60*1000 + 9*60*60*1000)
          const informationData = {
            type: 'information',
            id: nowDate.getTime() + '-' + createdCounselingTopicsId,
            notificationTargetGroup: 'adviser',
            notificationTargetDetail: "[\"all\"]",
            notificationText: '新規の相談が投稿されました。内容を確認し、回答をお願いします。',
            notificationUrl: location.href + '/' + createdCounselingTopicsId,
            notificationStartDate: notificationStartDate.getUTCFullYear() + '-'
                                    + ('0' + (notificationStartDate.getUTCMonth() + 1)).slice(-2) + '-'
                                    + ('0' + notificationStartDate.getUTCDate()).slice(-2) + 'T'
                                    + ('0' + notificationStartDate.getUTCHours()).slice(-2) + ':'
                                    + ('0' + notificationStartDate.getUTCMinutes()).slice(-2) + ':'
                                    + ('0' + notificationStartDate.getUTCSeconds()).slice(-2)
                                    + '+09:00',
            notificationEndDate: notificationEndDate.getUTCFullYear() + '-'
                                    + ('0' + (notificationEndDate.getUTCMonth() + 1)).slice(-2) + '-'
                                    + ('0' + notificationEndDate.getUTCDate()).slice(-2) + 'T'
                                    + ('0' + notificationEndDate.getUTCHours()).slice(-2) + ':'
                                    + ('0' + notificationEndDate.getUTCMinutes()).slice(-2) + ':'
                                    + ('0' + notificationEndDate.getUTCSeconds()).slice(-2)
                                    + '+09:00',   // 2日後に掲載終了
            notificationType: '新規相談のお知らせ',
            addUser: 'system',
            createAt: new Date(),
            updateAt: new Date()
          }

          try {
            await API.graphql(graphqlOperation(
              createInformation, { input: informationData }
            ))

            var d = new Date()
            var nowYear = d.getFullYear()

            // メール通知
            let adviserData = await API.graphql(graphqlOperation(
              listUsersBySpecificType, {type: 'adviser'}
            ))

            // Slack #adviser_notice への通知のための宛先を追加
            // 本番以外 #dev_adviser_notice への通知
            var devNoticeAdviserChannel = 'dev_adviser_notice-aaaaejkg6tbtfodmqbdukh4bee@zine-inc.slack.com'
            // 本番 #adviser_notice への通知
            var prodNoticeAdviserChannel = 'adviser_notice-aaaaejhnjjaimvp7sfvcxnkh4i@zine-inc.slack.com'

            var noticeAdviserChannel = ''
            if (location.hostname === 'dev.d2q78m2xs8yfz1.amplifyapp.com' || location.hostname === 'localhost') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname.match(/^feature-.*\.d2q78m2xs8yfz1\.amplifyapp\.com$/)) {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname === 'design.d2q78m2xs8yfz1.amplifyapp.com') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname === 'staging.d2q78m2xs8yfz1.amplifyapp.com') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else if (location.hostname === 'payment.d2q78m2xs8yfz1.amplifyapp.com') {
              noticeAdviserChannel = devNoticeAdviserChannel
            } else {
              noticeAdviserChannel = prodNoticeAdviserChannel
            }
            var serviceName = this.getServiceName(location.hostname)
            var adviserTask = '48時間以内にアドバイザーからの回答をお願いします。'
            this.appClass = this.getAppDivClass(location.hostname)
            if (this.appClass === 'hama') {
              adviserTask = 'まずCancerWithのアドバイザーが一次回答を行います。その後、必要に応じて、相談内容にマッチする浜松医大のアドバイザーに個別に連絡します。'
            }            

            // アドバイザー情報に通知用のデータを追加
            var adviserTmpDataForSlackNotice = {
              id : 'notice',
              mailAddress : noticeAdviserChannel
            }
            adviserData.data.listUsersBySpecificType.items.push(adviserTmpDataForSlackNotice)

            for (let key in adviserData.data.listUsersBySpecificType.items) {
              let targetUserid = adviserData.data.listUsersBySpecificType.items[key].id
              let targetMailAddress = adviserData.data.listUsersBySpecificType.items[key].mailAddress

              // アドバイザー分ループして全アドバイザー個別にレコード追加
              let mailNotificationData = {
                type: 'mailNotification',
                targetUserid: targetUserid,
                mailAddress: targetMailAddress,
                subject: '【' + serviceName + '】新しい相談が投稿されました',
                message: "いつも" + serviceName + "をご利用いただきありがとうございます。\n\n新しい相談が投稿されました。\n" + informationData['notificationUrl'] + "\n\n"
                      + adviserTask + "\n\n"
                      + "-----\n※本メールは送信専用のメールアドレスから自動配信しています。\n※運営にお問い合わせいただく際は、support@cancerwith.com までご連絡ください。\n\n"
                      + "Copyright (C) " + nowYear + " ZINE INC. All Rights Reserved.",
                addUser: 'system',
                createAt: informationData['createAt'],
                isNeededBackupBcc: true,
                isNeededAsanaForward: false
              }



              try {
                await API.graphql(graphqlOperation(
                  createMailNotification, { input: mailNotificationData }
                ))
              } catch (error) {
                logger.error(JSON.stringify(error))
                Analytics.record({
                  name: 'errorLog',
                  attributes: {
                    page: 'CounselingDetailCreate',
                    url: window.location.origin + window.location.pathname,
                    userid: this.id,
                    userType: this.userType,
                    errorType: 'MainNotification Create : createMailNotification',
                    errorNumber: 'CounselingDetailCreate-06',
                    errorMessage: JSON.stringify(error)
                  }
                });

                let errorLog = {
                  type: 'errorLog',
                  page: 'CounselingDetailCreate',
                  url: window.location.origin + window.location.pathname,
                  userid: this.id,
                  userType: this.userType,
                  errorType: 'MainNotification Create : createMailNotification',
                  errorNumber: 'CounselingDetailCreate-06',
                  errorMessage: JSON.stringify(error),
                  addUser: 'system',
                  createAt: new Date()
                }
                API.graphql(graphqlOperation(
                  createErrorLog, { input: errorLog }
                ))
              }
            }

            // 相談者自身への受け付け通知
            const mailNotificationDataForPostAcceptaance = {
              type: 'mailNotification',
              targetUserid: this.id,
              mailAddress: this.mailaddress,
              subject: '【' + serviceName +  '】相談を受け付けました',
              message: "いつも" + serviceName + "をご利用いただきありがとうございます。\n\n相談を受け付けました。\n" + informationData['notificationUrl'] + "\n\n"
                      + "48時間以内にアドバイザーからの回答を予定しています。\nアドバイザーからの回答がありましたら、サイト上およびメールにてご連絡いたします。\n\n"
                      + "-----\n※本メールは送信専用のメールアドレスから自動配信しています。\n※運営にお問い合わせいただく際は、support@cancerwith.com までご連絡ください。\n\n"
                      + "Copyright (C) " + nowYear + " ZINE INC. All Rights Reserved.",
              addUser: 'system',
              createAt: informationData['createAt'],
              isNeededBackupBcc: true,
              isNeededAsanaForward: false
            }
            await API.graphql(graphqlOperation(
              createMailNotification, { input: mailNotificationDataForPostAcceptaance }
            ))

            // 新規相談内容のパトロール用のAsana転送用通知
            const mailNotificationDataForAsanaForward = {
              type: 'mailNotification',
              targetUserid: this.id,
              mailAddress: 'ikeda+CancerWithAsanaForward@zineinc.co.jp',
              subject: '【' + serviceName + '】相談を受け付けました - UserID: ' + this.id + ' ' + informationData['notificationUrl'],
              message: "いつも" + serviceName + "をご利用いただきありがとうございます。\n\n相談を受け付けました。\n" + informationData['notificationUrl'] + "\n\n"
                      + "48時間以内にアドバイザーからの回答を予定しています。\nアドバイザーからの回答がありましたら、サイト上およびメールにてご連絡いたします。\n\n"
                      + "-----\n※本メールは送信専用のメールアドレスから自動配信しています。\n※運営にお問い合わせいただく際は、support@cancerwith.com までご連絡ください。\n\n"
                      + "Copyright (C) " + nowYear + " ZINE INC. All Rights Reserved.",
              addUser: 'system',
              createAt: informationData['createAt'],
              isNeededBackupBcc: false,
              isNeededAsanaForward: true
            }
            await API.graphql(graphqlOperation(
              createMailNotification, { input: mailNotificationDataForAsanaForward }
            ))


            // すべての処理が完了したらページ遷移(お知らせの追加は失敗しても許容)
            this.$router.push({ path: 'counselingList' + '?type=CounselingDetailCreated' })
          } catch (error) {
            logger.error(JSON.stringify(error))
            Analytics.record({
              name: 'errorLog', 
              attributes: { 
                page: 'CounselingDetailCreate',
                url: window.location.origin + window.location.pathname,
                userid: this.id,
                userType: this.userType,
                errorType: 'Information Create : createInformation',
                errorNumber: 'CounselingDetailCreate-04',
                errorMessage: JSON.stringify(error)
              }
            });

            const errorLog = {
              type: 'errorLog',
              page: 'CounselingDetailCreate',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Information Create : createInformation',
              errorNumber: 'CounselingDetailCreate-04',
              errorMessage: JSON.stringify(error),
              addUser: 'system',
              createAt: new Date()
            }
            await API.graphql(graphqlOperation(
              createErrorLog, { input: errorLog }
            ))
            // すべての処理が完了したらページ遷移(お知らせの追加は失敗しても許容)
            this.$router.push({ path: 'counselingList' + '?type=CounselingDetailCreated' })
          }

        } catch (error) {
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingDetailCreate',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'CounselingTopicsData Create : createdCounselingTopicsData and createInformation',
              errorNumber: 'CounselingDetailCreate-05',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingDetailCreate',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'CounselingTopicsData Create : createdCounselingTopicsData and createInformation',
            errorNumber: 'CounselingDetailCreate-05',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("保存に失敗しました\n未入力項目がないか確認してください")
        }
      }
    },
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email

      let currentCredentials = await Auth.currentCredentials()
      this.identityId = currentCredentials.identityId
    } catch (err) {
      this.signedIn = false
    }

    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(graphqlOperation(
        listUsersBySpecificUser, {mailAddress: this.mailaddress, limit: 1}
      ))
      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type
      this.displayName = userData.data.listUsersBySpecificUser.items[0].displayName

      // 課金モードの確認
      this.paymentActiveStatus = this.getPaymentActiveStatus(location.hostname)

      // 支払いステータス
      if (this.paymentActiveStatus) {
        this.paymentCustomerId = userData.data.listUsersBySpecificUser.items[0].paymentCustomerId
        this.paymentSubscriptionStatus = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionStatus
        this.paymentSubscriptionStartAt = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionStartAt
        this.paymentSubscriptionEndAt = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionEndAt
        this.paymentMode = this.getPaymentMode(this.paymentSubscriptionStatus, this.paymentSubscriptionStartAt, this.paymentSubscriptionEndAt)
      }
    
      if (userData.data.listUsersBySpecificUser.items[0].counselledCounts) {
        this.counselledCounts = JSON.parse(userData.data.listUsersBySpecificUser.items[0].counselledCounts)
      } else {
        this.counselledCounts= JSON.parse('[]')
      }

      /*
      // counselledCountからthisMonthCounselledCountを取得
      var nowDate = new Date()
      this.nowMonthStr = nowDate.getFullYear() + ('0' + (nowDate.getMonth() + 1)).slice(-2)
      this.counselledCounts.find(counselledCount => {
        if (counselledCount.month ==  this.nowMonthStr) {
          this.thisMonthCounselledCount = counselledCount.count
        }
      })
      */

      // 相談上限チェック
      if (this.paymentMode !== 'ベーシックプラン' && this.counselledCounts.length >= 1 && this.paymentActiveStatus) {
        this.isCounsellingExcess = true
      }

      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
          this.hasUserData = true 
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
      this.questionnaireUrl = 'https://share.hsforms.com/1aNOKiXsBTUKgmykiEgURIQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env
      this.isLoading = false
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
          this.questionnaireUrl = ''
          this.isLoading = false
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
          this.questionnaireUrl = ''
          this.isLoading = false
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
        this.questionnaireUrl = ''
        this.isLoading = false
        this.$router.push({ path: '../dashboard?createButton=' + this.$route.query.createButton })
      }
    }

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'CounselingDetailCreate',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/counselingDetailCreate',
          page_title: 'User:新規相談 (/counselingDetailCreate)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/counselingDetailCreate',
          page_title: 'Adviser:新規相談 (/counselingDetailCreate)'
        })
      }
    }
  }
};
</script>

<style src="./assets/style.css" />
